import moment from 'moment'
import { statsService } from '../services'
import { base64StringToBlob } from 'blob-util'

const state = {
  dateRangeStart: moment(),
  dateRangeEnd: moment(),
  info: {},
  status: {
    loading: false,
    loaded: false,
    notFound: false,
    saving: false,
    saved: false,
    progress: 0
  }
}

const actions = {
  getAll ({ dispatch, commit }, filter) {
    commit('getAllStats', filter)

    statsService.getAll(filter.site, filter.datefrom, filter.dateto)
      .then(
        stats => {
          if (!stats) {
            commit('getAllStatsNotFound')
          } else {
            commit('getAllStatsSuccess', stats)
          }

          dispatch('alert/clear', null, { root: true })
        },
        error => {
          commit('getAllStatsFailure')
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  getTotals ({ dispatch, commit }, filter) {
    commit('getAllStats', filter)

    statsService.getTotals(filter)
      .then(
        totals => {
          if (!totals) {
            commit('getAllStatsNotFound')
          } else {
            commit('getTotalsSuccess', totals)
          }

          dispatch('alert/clear', null, { root: true })
        },
        error => {
          commit('getAllStatsFailure')
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  getTotalsRange ({ dispatch, commit }, filter) {
    commit('getAllStats', filter)
    statsService.getTotalsRange(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        totals => {
          if (!totals) {
            commit('getAllStatsNotFound')
          } else {
            commit('getTotalsSuccess', totals)
          }

          dispatch('alert/clear', null, { root: true })
        },
        error => {
          commit('getAllStatsFailure')
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  clear ({ commit }) {
    commit('clearSubmission')
  },
  getHistorical ({ dispatch, commit }, filter) {
    commit('getAllStats', filter)
    statsService.getHistorical(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        totals => {
          if (!totals) {
            commit('getAllStatsNotFound')
          } else {
            commit('getTotalsSuccess', totals)
          }

          dispatch('alert/clear', null, { root: true })
        },
        error => {
          commit('getAllStatsFailure')
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  getSystem ({ dispatch, commit }, filter) {
    commit('getAllStats', filter)
    statsService.getSystem(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        totals => {
          if (!totals) {
            commit('getAllStatsNotFound')
          } else {
            commit('getTotalsSuccess', totals)
          }

          dispatch('alert/clear', null, { root: true })
        },
        error => {
          commit('getAllStatsFailure')
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  getUptime ({ dispatch, commit }, filter) {
    commit('getAllStats', filter)
    statsService.getUptime(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        totals => {
          if (!totals) {
            commit('getAllStatsNotFound')
          } else {
            commit('getTotalsSuccess', totals)
          }

          dispatch('alert/clear', null, { root: true })
        },
        error => {
          commit('getAllStatsFailure')
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  getUptimePdf ({ dispatch, commit }, filter) {
    statsService.getUptimePdf(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        (response) => {
          const contentType = 'application/pdf'
          const file = base64StringToBlob(response, contentType)
          console.log(response)
          const url = window.URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Uptime.pdf')
          document.body.appendChild(link)
          link.click()
        }
      )
  },
  getSystemPdf ({ dispatch, commit }, filter) {
    statsService.getSystemPdf(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        (response) => {
          const contentType = 'application/pdf'
          const file = base64StringToBlob(response, contentType)
          console.log(response)
          const url = window.URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'System.pdf')
          document.body.appendChild(link)
          link.click()
        }
      )
  },
  getHistoricalPdf ({ dispatch, commit }, filter) {
    statsService.getHistoricalPdf(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        (response) => {
          const contentType = 'application/pdf'
          const file = base64StringToBlob(response, contentType)
          console.log(response)
          const url = window.URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Historical.pdf')
          document.body.appendChild(link)
          link.click()
        }
      )
  },
  getDateRangePdf ({ dispatch, commit }, filter) {
    statsService.getDateRangePdf(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        (response) => {
          const contentType = 'application/pdf'
          const file = base64StringToBlob(response, contentType)
          console.log(response)
          const url = window.URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'TotalsDateRange.pdf')
          document.body.appendChild(link)
          link.click()
        }
      )
  },
  getTotalsPdf ({ dispatch, commit }, filter) {
    statsService.getTotalsPdf(filter, state.dateRangeStart, state.dateRangeEnd)
      .then(
        (response) => {
          const contentType = 'application/pdf'
          const file = base64StringToBlob(response, contentType)
          console.log(response)
          const url = window.URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Totals.pdf')
          document.body.appendChild(link)
          link.click()
        }
      )
  },
  updateStartDate ({ commit }, newDate) {
    console.log('date updated')
    commit('setDateRangeStart', newDate)
  },
  updateEndDate ({ commit }, newDate) {
    commit('setDateRangeEnd', newDate)
  }
}

const mutations = {
  getAllStats (state, filter) {
    state.info = {
      filter: filter
    }
    state.status = {
      loading: true,
      loaded: false,
      notFound: false,
      saving: false,
      saved: false,
      progress: 0
    }
  },
  getAllStatsNotFound (state) {
    state.info = null
    state.status = {
      loading: false,
      loaded: true,
      notFound: false,
      saving: false,
      saved: false,
      progress: 0
    }
  },
  getAllStatsSuccess (state, stats) {
    state.info.stats = stats
    state.status = {
      loading: false,
      loaded: true,
      notFound: false,
      saving: false,
      saved: false,
      progress: 0
    }
  },
  getAllStatsFailure (state) {
    state.info = null
    state.status = {
      loading: false,
      loaded: true,
      notFound: false,
      saving: false,
      saved: false,
      progress: 0
    }
  },
  getTotalsSuccess (state, totals) {
    state.info.totals = totals
    state.status = {
      loading: false,
      loaded: true,
      notFound: false,
      saving: false,
      saved: false,
      progress: 0
    }
  },
  clearSubmission (state) {
    state.info = null
    state.status = {
      loading: false,
      loaded: false,
      notFound: false,
      saving: false,
      saved: false,
      progress: 100
    }
  },
  setDateRangeStart (state, newDate) {
    state.dateRangeStart = newDate
  },
  setDateRangeEnd (state, newDate) {
    state.dateRangeEnd = newDate
  }
}

export const stats = {
  namespaced: true,
  state,
  actions,
  mutations
}
